/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class PJMRealTimePrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "PJMRealTimePrices";
}

const servicePlugin = makeServicePlugin({
  Model: PJMRealTimePrices,
  service: feathersClient.service("data-services/pjm/real-time-locational-marginal-prices"),
  idField: "_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
